import React from "react";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import { Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

const PaginationHandlerComponent = ({ handleClick, disablePrevious, disableNext, page, lastPage }) => {
  const classes = useStyles();
  const paginationInfo = `Page ${page} of ${lastPage}`;

  return (
    <div className={classes.paginationContainer}>
      <div>
        <IconButton disabled={disablePrevious} onClick={() => handleClick(false)}>
          <ArrowBackIosRoundedIcon fontSize={"small"} />
        </IconButton>
        <IconButton disabled={disableNext} onClick={() => handleClick(true)}>
          <ArrowForwardIosRoundedIcon fontSize={"small"} />
        </IconButton>
      </div>
      {!!page && !!lastPage && <Typography>{paginationInfo}</Typography>}
    </div>
  );
};

export default PaginationHandlerComponent;
